export default "__VITE_ASSET__1fc877bc__"